import React from 'react'
import PropTypes from 'prop-types'

function SpaceBetween ({ children, className, align, onClick, style }) {
  const alignment = {
    center: 'items-center',
    top: 'items-start',
    bottom: 'items-end'
  }

  const classNames = [
    'flex',
    'justify-between',
    'w-full',
    alignment[align] || alignment.center
  ]

  return (
    <div className={className} onClick={onClick} style={style}>
      <div className={classNames.join(' ')}>
        {children}
      </div>
    </div>
  )
}

SpaceBetween.defaultProps = {
  className: null,
  align: 'center'
}

SpaceBetween.propTypes = {
  /**
     * Add a custom className to the wrapper
     */
  className: PropTypes.string,
  /**
     * Alignment of the content in the component
     */
  align: PropTypes.oneOf(['center', 'top', 'bottom'])
}

export default SpaceBetween
